import { render, staticRenderFns } from "./TwoColImages.vue?vue&type=template&id=534b9bea&scoped=true"
import script from "./TwoColImages.vue?vue&type=script&lang=js"
export * from "./TwoColImages.vue?vue&type=script&lang=js"
import style0 from "./TwoColImages.vue?vue&type=style&index=0&id=534b9bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b9bea",
  null
  
)

export default component.exports